(function () {
  /* The Written Hug: send timing, and the digital-now choice.
     Continues the closure started in twh-delivery.js via TWH_DELIVERY_CTX,
     the same pattern twh-delivery-address.js uses. Split into its own file
     because a single theme file over 20,000 bytes is silently truncated on
     write (see twh-theme-write-20k-truncation-2026-08).

     WHY THIS EXISTS
     twh-delivery.js already shipped an optional "When should it arrive?" date
     that posts as properties[Arrive by], and the fulfilment Worker already
     forwards it to Cardly as requestedArrival. Two things were missing:
       1. The date read as a nice-to-have, so nobody used it. Making it an
          explicit two-way choice is what turns one card into four.
       2. Nothing offered the buyer a way to give the recipient something
          immediately when they bought at the last minute.
     Both are UI over line item properties that already exist or are read by
     the Worker. No new storage, no accounts. */
  var CTX = window.TWH_DELIVERY_CTX;
  if (!CTX) return;
  var wrap = CTX.wrap;
  var msg = document.getElementById('twh-message');
  var FID = msg && msg.getAttribute('form');
  if (!FID) return;

  var arriveBlock = wrap.querySelector('.twh-dl-arrive');
  var arrive = wrap.querySelector('#twh-dl-arrive');
  if (!arriveBlock || !arrive) return;

  /* ---------- 1. Mail it now, or arrive by a date ---------- */

  /* The existing date input is REUSED, not replaced: it keeps its id and its
     properties[Arrive by] name so the Worker's arriveBy() parser, the order
     confirmation email and every historical order stay valid. All that changes
     is that it now lives behind a deliberate choice, and is DISABLED when the
     buyer picks "now" - a disabled input posts nothing, which is exactly the
     empty "Arrive by" the Worker already treats as mail-immediately. */
  var choice = document.createElement('div');
  choice.className = 'twh-when';
  choice.innerHTML =
    '<label class="twh-dl-opt"><input type="radio" name="properties[Mail when]" value="Now" checked>' +
    '<span><strong>Mail it now</strong>We write it and post it within 1 to 3 business days.</span></label>' +
    '<label class="twh-dl-opt"><input type="radio" name="properties[Mail when]" value="On a date">' +
    '<span><strong>Save it for the day</strong>Pick when it should land. We hold it and mail it in time.</span></label>';

  var legend = arriveBlock.querySelector('label.twh-label');
  if (legend) legend.textContent = 'When should we mail it?';
  arriveBlock.insertBefore(choice, legend ? legend.nextSibling : arriveBlock.firstChild);

  var dateWrap = document.createElement('div');
  dateWrap.className = 'twh-when-date';
  arrive.parentNode.insertBefore(dateWrap, arrive);
  dateWrap.appendChild(arrive);
  var arriveNote = arriveBlock.querySelector('.twh-dl-arrivenote');
  if (arriveNote) dateWrap.appendChild(arriveNote);
  if (arriveNote) {
    arriveNote.textContent = 'We aim to land it on or just before this day. Exact day is not guaranteed, and you can change or cancel it until we send it to print.';
  }

  function whenPicked() {
    var r = choice.querySelector('input[value="On a date"]');
    return !!(r && r.checked);
  }
  function syncWhen() {
    var onDate = whenPicked();
    dateWrap.hidden = !onDate;
    arrive.disabled = !onDate;
    arrive.required = onDate;
    if (!onDate) { arrive.value = ''; arrive.setCustomValidity(''); }
  }
  choice.addEventListener('change', function (e) {
    if (e.target && e.target.name === 'properties[Mail when]') syncWhen();
  });

  /* ---------- 2. Digital now ---------- */

  /* The $5 card video is already built and already client side. All that was
     missing was somewhere to send it. Eric's decision 2026-08-13: the BUYER
     chooses whether it lands in their own inbox or the recipient's. The buyer
     choosing IS the permission, which keeps this inside the standing rule that
     a message is only ever shared with the sender's consent.

     The Worker rebuilds the video link itself from the order's own properties,
     so nothing about the card is stored anywhere and no token backend exists.
     These two fields only tell it WHO to send to. */
  var dig = document.createElement('div');
  dig.className = 'twh-dl-digital';
  dig.innerHTML =
    '<label class="twh-label" for="twh-dl-remail">Their email <span>optional</span></label>' +
    '<input id="twh-dl-remail" type="email" name="properties[Recipient email]" autocomplete="off" maxlength="120" placeholder="them@example.com">' +
    '<p class="twh-dl-arrivenote">Only used for the digital card. We never add anyone to a mailing list.</p>' +
    '<div class="twh-dig-opts" hidden>' +
      '<label class="twh-dl-opt"><input type="radio" name="properties[Digital to]" value="Me" checked>' +
      '<span><strong>Send the digital card to me</strong>You pass it on whenever you like.</span></label>' +
      '<label class="twh-dl-opt"><input type="radio" name="properties[Digital to]" value="Them">' +
      '<span><strong>Send it to them now</strong>They get something today while the real card is in the post.</span></label>' +
    '</div>';
  arriveBlock.parentNode.insertBefore(dig, arriveBlock.nextSibling);

  var remail = dig.querySelector('#twh-dl-remail');
  var digOpts = dig.querySelector('.twh-dig-opts');
  var digThem = dig.querySelector('input[value="Them"]');
  var digMe = dig.querySelector('input[value="Me"]');

  /* The destination choice only appears once there is somewhere to send it,
     so an empty field never presents a dead option. If the buyer clears the
     email again the choice falls back to "me" rather than silently keeping a
     selection they can no longer honour. */
  function syncDigital() {
    var has = !!(remail.value || '').trim() && remail.checkValidity();
    digOpts.hidden = !has;
    if (!has && digThem && digThem.checked && digMe) digMe.checked = true;
  }
  remail.addEventListener('input', syncDigital);
  remail.addEventListener('blur', syncDigital);

  /* ---------- 3. Both blocks follow the "straight to them" toggle ---------- */

  /* twh-delivery.js hides .twh-dl-fields when the buyer mails to themselves
     first. The recipient email belongs with that group: there is no recipient
     inbox to send to when the card is coming to the buyer. The DATE is
     deliberately NOT tied to it, because holding a card for a date is just as
     valid when it is mailed to the buyer. */
  function mailingToThem() {
    var r = wrap.querySelector('input[value="Straight to them"]');
    return !!(r && r.checked);
  }
  function syncMailTo() {
    var toThem = mailingToThem();
    dig.hidden = !toThem;
    remail.disabled = !toThem;
    if (digThem) digThem.disabled = !toThem;
    if (digMe) digMe.disabled = !toThem;
    if (!toThem) { remail.value = ''; }
    syncDigital();
  }
  wrap.addEventListener('change', function (e) {
    if (e.target && e.target.name === 'properties[Mail to]') syncMailTo();
  });

  /* Every new input posts with the product form, exactly like the fields
     twh-delivery.js created. The form ATTRIBUTE does not care about DOM order,
     which is why these can be appended after the buy buttons already rendered. */
  [].forEach.call(choice.querySelectorAll('input'), function (el) { el.setAttribute('form', FID); });
  [].forEach.call(dig.querySelectorAll('input'), function (el) { el.setAttribute('form', FID); });

  /* ---------- 4. Carry-over from the "set up your year" prompt ---------- */

  /* twh-year.js sends shoppers here with twh_year=1 when they are building a
     run of cards. Open on the date choice and put it in front of them, because
     someone who arrived from that prompt has already decided they want one. */
  var wantsDate = false;
  try {
    wantsDate = /(?:^|[?&])twh_year=1(?:&|$)/.test(location.search) ||
      sessionStorage.getItem('twh_year') === '1';
    if (/(?:^|[?&])twh_year=1(?:&|$)/.test(location.search)) sessionStorage.setItem('twh_year', '1');
  } catch (e) {}
  if (wantsDate) {
    var onDate = choice.querySelector('input[value="On a date"]');
    if (onDate) { onDate.checked = true; }
  }

  syncWhen();
  syncMailTo();

  if (wantsDate) {
    setTimeout(function () {
      try { arriveBlock.scrollIntoView({ behavior: 'smooth', block: 'center' }); } catch (e) {}
    }, 400);
  }
})();
